import { call, delay, put, takeLatest } from 'redux-saga/effects'
import dayjs from 'dayjs'

import {
  PROGRESS_INDICATOR_TIMEOUT,
  X_ACCESS_TOKEN_COOKIE_NAME,
  X_ACCESS_TOKEN_COOKIE_DEFAULT_TTL,
  X_ACCESS_TOKEN_COOKIE_EXTENDED_TTL,
} from '../constants'
import * as actions from '../actionTypes'
import { login } from '../api'
import { expireCookie, setCookie } from '../utils'

function* loginSaga(action) {
  try {
    const { campusKey, password, rememberMe } = action.payload
    const { token, user } = yield call(login, campusKey, password, rememberMe)
    const ttl = rememberMe ? X_ACCESS_TOKEN_COOKIE_EXTENDED_TTL : X_ACCESS_TOKEN_COOKIE_DEFAULT_TTL
    const tokenExpiration = dayjs().utc().add(ttl, 's').toString()
    setCookie(X_ACCESS_TOKEN_COOKIE_NAME, token, tokenExpiration)
    yield delay(PROGRESS_INDICATOR_TIMEOUT) // prevent loading indicator flash
    yield put({ type: actions.LOGIN_REQUEST_SUCCESS, payload: { user } })
  } catch (e) {
    yield put({ type: actions.LOGIN_REQUEST_FAILURE, payload: e })
  }
}

function* logoutSaga() {
  try {
    expireCookie(X_ACCESS_TOKEN_COOKIE_NAME)
    yield put({ type: actions.LOGOUT_REQUEST_SUCCESS })
  } catch (e) {
    yield put({ type: actions.LOGOUT_REQUEST_FAILURE, payload: e })
  }
}

const authenticationSaga = [
  takeLatest(actions.LOGIN_REQUEST, loginSaga),
  takeLatest(actions.LOGOUT_REQUEST, logoutSaga),
]

export default authenticationSaga
